import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { About } from "./components/About";
import { Services } from "./components/Services";
import { Devotionals } from "./components/Devotionals";
import { Donations } from "./components/Donations";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { DailyDevotionalPopup } from "./components/DailyDevotionalPopup";
import { AdminNotifications } from "./components/AdminNotifications";
import { IntakeForm } from "./components/IntakeForm";
import SpiritualToolbox from "./components/SpiritualToolbox";
import ErrorBoundary from "./ErrorBoundary";

// Main website component
const MainWebsite = () => (
  <>
    <Header />
    <Hero />
    <About />
    <Services />
    <Devotionals />
    <Donations />
    <Contact />
    <Footer />
    <DailyDevotionalPopup />
  </>
);

function App() {
  return (
    <ErrorBoundary>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<MainWebsite />} />
            <Route path="/admin" element={<AdminNotifications />} />
            <Route path="/intake-form" element={<IntakeForm />} />
            <Route path="/spiritual-toolbox" element={<SpiritualToolbox />} />
          </Routes>
        </BrowserRouter>
      </div>
    </ErrorBoundary>
  );
}

export default App;